const piTags = [
    {
        'key': 'opening',
        'title': 'Opening',
        'description': 'This PI focuses on your ability to open conversations and presentations in a purposeful, engaging, impactful way by employing techniques taught in LifeHikes courses.'
    },
    {
        'key': 'language_strength',
        'title': 'Language Strength',
        'description': 'This PI focuses on your ability to consciously employ strong, specific, persuasive, impactful language AND your ability to simultaneously avoid weak, vague, filler language while speaking and presenting.'
    },
    {
        'key': 'uniqueness',
        'title': 'Uniqueness',
        'description': ''
    },
    {
        'key': 'interesting',
        'title': 'Interesting',
        'description': ''
    },
    {
        'key': 'clarity',
        'title': 'Clarity',
        'description': 'This PI focuses on your ability to convey your message, argument, agenda, and/or point to your audience in a manner that is clear, concise, and easily understood.'
    },
    {
        'key': 'memorability',
        'title': 'Memorability',
        'description': 'This PI focuses on your ability to craft and present your message in a way that sticks with your audience even after the conversation or presentation ends.'
    },
    {
        'key': 'stories',
        'title': 'Stories',
        'description': 'This PI focuses on your ability to craft and share stories and anecdotes such that your message becomes more persuasive, memorable, and real.'
    },
    {
        'key': 'data',
        'title': 'Data',
        'description': 'This PI focuses on your ability to share and utilize data while speaking and presenting in a persuasive and engaging way.'
    },
    {
        'key': 'closing',
        'title': 'Closing',
        'description': 'This PI focuses on your ability to craft and execute a compelling, thoughtful closing component to a conversation or presentation.'
    },
    {
        'key': 'eye_contact',
        'title': 'Eye Contact',
        'description': 'This PI focuses on your ability to maintain meaningful eye contact with your audience/camera in a way that helps engender connection between speaker and audience.'
    },
    {
        'key': 'authenticity',
        'title': 'Authenticity',
        'description': ''
    },
    {
        'key': 'personalization',
        'title': 'Personalization',
        'description': 'The PI focuses on your ability to adjust your message, content, and/or delivery to your specific audience.'
    },
    {
        'key': 'audience_involvement',
        'title': 'Audience Involvement',
        'description': 'This PI focuses on your ability to purposefully engage with your audience by employing involvement techniques taught in LifeHikes courses.'
    },
    {
        'key': 'responsiveness',
        'title': 'Responsiveness',
        'description': ''
    },
    {
        'key': 'voice_modulation',
        'title': 'Voice Modulation',
        'description': 'This PI focuses on your ability to purposefully and appropriately use your full voice range in a way that enhances your message and content.'
    },
    {
        'key': 'body_language',
        'title': 'Body Language',
        'description': 'This PI focuses on your ability to purposefully and appropriately use body language in a way that enhances your message and content.'
    },
    {
        'key': 'movement',
        'title': 'Movement',
        'description': 'This PI focuses on your ability to purposefully and appropriately use your full virtual frame or physical space in a way that enhances your message and content.'
    },
    {
        'key': 'sensory_engagement',
        'title': 'Sensory Engagement',
        'description': 'This PI focuses on your ability to purposefully and appropriately use props in a way that enhances your message and content.'
    },
    {
        'key': 'didactic',
        'title': 'Didactic/Socratic',
        'description': ''
    },
    {
        'key': 'variety',
        'title': 'Variety',
        'description': ''
    },
    {
        'key': 'value_proposition',
        'title': 'Value Proposition',
        'description': ''
    },
    {
        'key': 'discovery',
        'title': 'Discovery',
        'description': ''
    },
    {
        'key': 'conversational_intelligence',
        'title': 'Conversational Intelligence',
        'description': ''
    },
    {
        'key': 'flip',
        'title': 'Handling Objections: Flip',
        'description': ''
    },
    {
        'key': 'validate_pivot',
        'title': 'Handling Objections: Validate & Pivot',
        'description': ''
    },
    {
        'key': 'customizing_conversation',
        'title': 'Customizing Conversation',
        'description': ''
    },
    {
        'key': 'consultative_speaking',
        'title': 'Consultative Speaking',
        'description': ''
    },
    {
        'key': 'handling_objections',
        'title': 'Handling Objections',
        'description': ''
    },
    {
        'key': 'asking',
        'title': 'Asking',
        'description': ''
    },
    {
        'key': 'closing_commitment',
        'title': 'Closing and Securing Commitment',
        'description': ''
    },
    {
        'key': 'purposeful_prospecting',
        'title': 'Purposeful Prospecting',
        'description': ''
    },
    {
        'key': 'solid_systems',
        'title': 'Solid Systems',
        'description': ''
    },
    {
        'key': 'role_alignment',
        'title': 'Role Alignment',
        'description': ''
    },
    {
        'key': 'role_clarity',
        'title': 'Role Alignment',
        'description': ''
    },
    {
        'key': 'time_based',
        'title': 'Time-Based',
        'description': ''
    },
    {
        'key': 'commitment_results',
        'title': 'Plan for Role Development'
    },
    {
        'key': 'plan_role_development',
        'title': 'Plan for Role Development'
    },
    {
        'key': 'self_knowledge',
        'title': 'Self-Knowledge'
    },
    {
        'key': 'clear_KPIs',
        'title': 'Clear Statement of KPIs',
        'description': ''
    },
    {
        'key': 'candor',
        'title': 'Candor',
        'description': ''
    },
    {
        'key': 'reading_responding',
        'title': 'Reading and Responding to Situation',
        'description': ''
    },
    {
        'key': 'delegation',
        'title': 'Delegation',
        'description': ''
    },
    {
        'key': 'script_accuracy',
        'title': 'Script Accuracy',
        'description': ''
    },
    {
        'key': 'empathy',
        'title': 'Empathy',
        'description': ''
    },
    {
        'key': 'authentic_questions',
        'title': 'Authentic Questions',
        'description': ''
    },
    {
        'key': 'features_to_benefits',
        'title': 'Transforming Features to Benefits',
        'description': ''
    }
]

module.exports = {
    piTags
}